import React from "react";
import Parallax2 from "../common/parallax/Parallax2";
import AchievementSection1 from "./section1/AchievementSection1";
import AchievementSection2 from "./section2/AchievementSection2";
import AchievementSection3 from "./section3/AchievementSection3";
import AchievementSection4 from "./section4/AchievementSection4";

const Achievements = () => {
  return (
    <>
      <Parallax2 heading="ACHIEVEMENT" subHeading="OUR ACHIEVERS" />
      <AchievementSection4 />
      <AchievementSection3 />
      <AchievementSection1 />
      <AchievementSection2 />
    </>
  );
};

export default Achievements;
